import script from "./NewProgramInSpireStep3View.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProgramInSpireStep3View.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__